// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LibraryCardPersonalDetailsController {
   $log: any
   $scope: any
   addressTypes: any
   alerts: any
   configService: any
   detailFields: any
   details: any
   editableFields: any
   error: any
   i18n: any
   isLoading: any
   mode: any
   phoneTypes: any
   sierraService: any
   success: any
   libraryCardErrorHelper: any
   constructor($scope: any, $log: any, sierraService: any,  translationService: any, alertService: any, configService: any, libraryCardErrorHelper: any) {
      this.$onInit = this.$onInit.bind(this)
      this.$onChanges = this.$onChanges.bind(this)
      this.loadDetails = this.loadDetails.bind(this)
      this.waitOrLoadThenInit = this.waitOrLoadThenInit.bind(this)
      this.initDisplay = this.initDisplay.bind(this)
      this.showField = this.showField.bind(this)
      this.setMode = this.setMode.bind(this)
      this.phoneDescription = this.phoneDescription.bind(this)
      this.getOption = this.getOption.bind(this)
      this.addDetailField = this.addDetailField.bind(this)
      this.removeDetailField = this.removeDetailField.bind(this)
      this.sanitizeFormFieldToSend = this.sanitizeFormFieldToSend.bind(this)
      this.submitPersonalDetails = this.submitPersonalDetails.bind(this)
      this.sendDetails = this.sendDetails.bind(this)
      this.$scope = $scope
      this.$log = $log
      this.sierraService = sierraService
      this.configService = configService
      this.i18n = translationService
      this.isLoading = false
      this.details
      this.alerts = alertService
      this.libraryCardErrorHelper = libraryCardErrorHelper
      this.phoneTypes = [
         { code: 't', description: this.i18n.translations.PHONE_PRIMARY},
         { code: 'p', description: this.i18n.translations.PHONE_ALT},
         { code: 'o', description: this.i18n.translations.PHONE_MOB}
      ]
      this.addressTypes = [
         { code: 'a', description: this.i18n.translations.ADDRESS_PRIMARY},
         { code: 'h', description: this.i18n.translations.ADDRESS_ALT}
      ]
      this.detailFields = [
         { label: this.i18n.translations.NAME, key: 'username', value: '', type: 'text', multiple: false, read: true, write: false },
         { label: this.i18n.translations.EMAILS, key: 'emails', value: '', type: 'email', multiple: true, read: true, write: false, desc: ''},
         { label: this.i18n.translations.PHONES, key: 'phones', value: { 
            number : "", type: ""
         }, type: 'tel', multiple: true, read: true, write: false, desc: '', helperDesc: this.i18n.translations.SELECT_PHONE_TYPE, helperOptions: this.phoneTypes},
         // @ts-expect-error TS(1117) FIXME: An object literal cannot have multiple properties ... Remove this comment to see the full error message
         { label: this.i18n.translations.PIN, key: 'pin', value: '', type: 'text', multiple: false, read: false, write: false, desc: '', hidden: true, desc: 'xxxxxxxx' },
         { label: this.i18n.translations.ADDRESSES, key: 'addresses', value: { 
            lines : ["", ""], type: ""
         }, type: 'addr', multiple: true, read: true, write: false, desc: '', helperDesc: this.i18n.translations.TYPE, helperOptions: this.addressTypes},
         { label: this.i18n.translations.BIRTH_DATE, key: 'birthDate', value: '', type: 'date', multiple: false, read: true, write: false},
         { label: this.i18n.translations.BARCODES, key: 'barcodes', value: '', type: 'text', multiple: true, read: true, write: false}
      ]
    
      this.mode = 'SHOW'
      this.editableFields = this.configService.data.libraryCard.editablePersonalDetails
      if (this.sierraService.userIdentifierIsMail()) {
         this.editableFields = _.filter(this.editableFields, (field: any) => field.name !== 'EMAILS')
      }
   }

   $onInit() {
      this.applyEditableFieldsConfig()
      return this.loadDetails()
   }

   $onChanges(changesObj: any) {
      if (changesObj.reloadTrigger.currentValue) {
         return this.loadDetails()
      }
   }

   applyEditableFieldsConfig() {
      const editableMap = {}
    
      this.editableFields.forEach((f: any) => {
         // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
         return editableMap[f.name.toLowerCase()] = true
      })
    
      return this.detailFields.forEach((field: any) => {
         // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
         return field.write = editableMap[field.key] || false
      })
   }

   loadDetails() {
      this.error = ""
      if (this.sierraService.isUserInfoNull()) {
         return this.waitOrLoadThenInit(this.sierraService.patronInfoLoadedPromise.promise)
      } else {
         return this.initDisplay()
      }
   }

   // promise param is the promise whose resolution we wait on to initialize DOM
   // formSuccess param, if present, is the success message that should be shown to users
   waitOrLoadThenInit(promise: any, formSuccess =  false) {
      this.isLoading = true
      return promise
         .then(() => { 
            this.isLoading = false
            this.initDisplay()
            if (formSuccess) {
               return this.alerts.pulseAlert('libraryCardSuccess', formSuccess, 5000)
            }
         }).catch((err: any) => {
            this.$log.error(err)
            this.isLoading = false
            const errorMessage = this.libraryCardErrorHelper.getLibraryCardErrorMessage(err, this.sierraService, this.i18n)     
            this.error = this.i18n.translate(this.i18n.translations.PERSONAL_DETAILS_ERROR, {error: errorMessage})
            return this.alerts.setAlert('libraryCardListLoadError', this.error)
         })
   }

   initDisplay() {
      this.details = this.sierraService.getLoadedUserInfo()
      if (this.details) {
         this.detailFields.forEach((field: any) => {
            field.isValuePresent = !!this.details[field.key]
            if (field.multiple) {
               const valueArray = this.details[field.key] || [ field.value ]
               field.values = _.map(valueArray, (val: any) => ({
                  value : val
               })) 
               return field.value = _.includes(['phones','addresses'], (field.key)) ? valueArray  : valueArray.join(', ')
            } else {
               if (field.isValuePresent) {
                  field.value = field.type === 'date' ? new Date(this.details[field.key] + "T00:00:00") : this.details[field.key]
               }
          
               return field.values = [ { value : field.value } ]
            }
         })
          
      } else {
         this.error = this.i18n.translations.PERSONAL_DETAILS_EMPTY_ERROR
         this.alerts.setAlert('libraryCardListLoadError', this.error)
      }
    
      return this.setMode('SHOW')
   }

   showField(field: any) {
      const canOrDoesExist = field.write || field.isValuePresent
      const isReading = (this.mode === 'SHOW') && field.read && field.isValuePresent
      return canOrDoesExist || isReading
   }

   setMode(mode: any) {
      return this.mode = mode
   }

   phoneDescription(code: any) {
      const description = this.getOption(this.phoneTypes, 'code', code)?.description
      return this.i18n.translate(description)
   }

   getOption(options: any, key: any, value: any) {
      return (_.filter(options, (option: any) => option[key] === value))[0]
   }

   addDetailField(index: any) {
      const field = this.detailFields[index]
      const defaultVal = field.key === 'phones' ? { number : "", type : ""} : field.key === 'addresses' ? { lines : ["", ""], type: ""} : ""
      return field.values.push( { value : defaultVal } )
   }

   removeDetailField(extraFieldIndex: any, attributeFieldIndex: any) {
      return this.detailFields[attributeFieldIndex].values.splice(extraFieldIndex, 1)
   }

   sanitizeFormFieldToSend(field: any) {
      switch (false) {
         case field.key !== "phones":
            return _.map(field.values, (valObj: any) => {
               return {
                  number : valObj.value.number,
                  type : valObj.value.model?.code || 't'
               }
            }) // add dummy code so empty number will delete existing

         case field.key !== "addresses":
            return _.map(field.values, (valObj: any) => {
               let formatted
               if (valObj.value.lines[1] === "") {
                  valObj.value.lines.pop() // if second line is empty, remove it from array
               }
               return formatted = {
                  lines : valObj.value.lines,
                  type : valObj.value.model?.code || 'a'
               }
            }) // add dummy code so empty lines will delete existing

         default:
         // sending [""] allows user to delete pre-existing value, while sending [] will make no changes to pre-existing value
            return _.map(field.values, (valObj: any) => valObj.value)
      }
   }

   submitPersonalDetails() {
      const detailObject = {}
      this.detailFields.forEach((field: any) => {
         if (!!field.write && !field.hidden) {
            if (field.multiple) {
               const valueArray = this.sanitizeFormFieldToSend(field)
               if (valueArray.length) { 
                  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                  return detailObject[field.key] = valueArray 
               }
            } else {
               // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
               return detailObject[field.key] = field.values[0].value
            }
         }
      }) 
      return this.sendDetails(detailObject)
   }

   sendDetails(params: any) {
      this.isLoading = true
      return this.sierraService.updateUserDetails(params)
         .then(() => {
            this.$log.debug(' details successfully updated ')
            this.success = this.i18n.translations.PERSONAL_DETAILS_UPDATE_SUCCESS
            this.waitOrLoadThenInit(this.sierraService.getOrRenewPatronInfo(), this.success)
            return window.scrollTo(0,0)
         }).catch((err: any) => {
            this.$log.error('error updating personal details ', err)
            this.isLoading = false
            this.error = this.i18n.translations.PERSONAL_DETAILS_UPDATE_ERROR
            this.alerts.pulseAlert('libraryCardError', this.error, 10000)
            return window.scrollTo(0,0)
         })
   }
}

LibraryCardPersonalDetailsController.$inject = ['$scope', '$log', 'sierraService', 'translationService', 'alertService', 'configService', 'libraryCardErrorHelper']

angular.module('summonApp.controllers')
   .controller('libraryCardPersonalDetailsController', LibraryCardPersonalDetailsController)
